import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=0251aec0"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=0251aec0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0251aec0')) {
      api.createRecord('0251aec0', component.options)
    } else {
      api.reload('0251aec0', component.options)
    }
    module.hot.accept("./Footer.vue?vue&type=template&id=0251aec0", function () {
      api.rerender('0251aec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/core/Footer.vue"
export default component.exports